module.exports = __webpack_public_path__ + "app/principal/buyers-list-2Y1WHZqX.html";